import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import PropTypes from 'prop-types'

const EmptyCartMessage = styled.div`
  ${tw`text-center p-4 mb-5`}
`
export default function EmptyCart({ message }) {
  return <EmptyCartMessage>{message || 'Your bag is empty.'}</EmptyCartMessage>
}

EmptyCart.propTypes = {
  message: PropTypes.string,
}
